import { Image } from '@/component/Image';

export const Hero = ({ children, name, headline, coverImage }) => {
  return (
    <section className="flex flex-col items-center relative w-full bg-cover">
      <div className="container relative flex flex-col justify-center !bg-transparent max-lg:pb-4 max-lg:h-auto lg:min-h-[625px] max-sm:py-4 sm:py-8 lg:py-20 3xl:mb-3 3xl:rounded-10">
        <div className="max-sm:w-full sm:max-lg:w-[1024px] absolute inset-0 z-[1] overflow-hidden max-lg:left-auto max-lg:right-0 3xl:rounded-10">
          <Image
            unoptimized
            src={
              coverImage?.url ||
              'https://guestit-web-assets.s3-accelerate.amazonaws.com/images/hero/header-listing-groups.webp'
            }
            className={`w-full 3xl:rounded-10 h-full absolute object-cover z-[1] inset-0 max-sm:object-[58%_0%] max-sm:min-h-[473px] sm:max-lg:min-w-[1812px] left-1/2 max-sm:top-1/2 max-sm:-translate-y-[54%] max-lg:-translate-x-1/2 lg:min-h-[1202px] lg:-translate-y-[27%] lg:-translate-x-1/2`}
            alt={name}
            loading="lazy"
            width={1812}
            height={625}
          />
        </div>
        <div className="relative z-[1] flex flex-col gap-[14px] max-sm:py-6 sm:py-10">
          <h1 className="max-sm:text-2xl max-sm:leading-[normal] sm:text-[56px] font-extrabold sm:leading-[60px] text-white max-sm:tracking-[0.2px] sm:tracking-[0.3px] sm:max-lg:max-w-[840px] lg:max-w-[1086px]">
            {name}
          </h1>
          <p className="max-sm:text-sm max-sm:font-normal sm:text-lg leading-7 text-white max-sm:max-w-[310px] sm:max-w-[640px]">
            {headline}
          </p>
        </div>
        <div className="max-sm:rounded-[18px] sm:rounded-20 text-white relative z-[2] sm:max-w-[720px]">
          {children}
        </div>
      </div>
    </section>
  );
};
